import { render, staticRenderFns } from "./resourceSelectionComp.vue?vue&type=template&id=c76adff4&scoped=true&"
import script from "./resourceSelectionComp.vue?vue&type=script&lang=js&"
export * from "./resourceSelectionComp.vue?vue&type=script&lang=js&"
import style0 from "./resourceSelectionComp.vue?vue&type=style&index=0&id=c76adff4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76adff4",
  null
  
)

export default component.exports